export default __webpack_public_path__ + "static/media/banner-dots.e896952f.svg";